import React, { useState } from 'react';
import './perferences.css';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';


function Preferences() {
  // State to manage the checked status of each checkbox
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);

  // Event handlers for checkbox changes
  const handleCheckboxChange1 = () => {
    setIsChecked1(!isChecked1);
  };

  const handleCheckboxChange2 = () => {
    setIsChecked2(!isChecked2);
  };

  const handleCheckboxChange3 = () => {
    setIsChecked3(!isChecked3);
  };
  const UpdateBtn = () => {
    Swal.fire({
      title: 'Update Confirmation',
      text: 'Are you sure you want to update?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, update it!',
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle the update logic here
        Swal.fire('Updated!', 'Your data has been updated.', 'success');
      }
    });
    // Your SaveButton logic her
  };

  return (
    <div className="p-2 ">
      <span className='breachCrumb'>
          <Link to="/user-setting-dashboard">Setting</Link> /{' '}
          <Link to="/user-setting-dashboard/preferences">Preference</Link>
        </span>
      <h5>Preferences</h5>
      <div className="checkbox-group border rounded col-md-6 p-4 mt-3">
      <div className='box2'>
          <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text"> Show employee name with code</label>
          </div>
          <div className="d-flex checkbox">
              <input type="checkbox" id="check" />
              <label type="text"> Show disable employees in report</label>
          </div>
          <div className="d-flex checkbox">
                <input type="checkbox" id="check" />
                <label type="text"> Use electronic signature</label>
          </div>
        </div>

        {/* <label className="checkbox pb-4">
          <input
            type="checkbox"
            checked={isChecked1}
            onChange={handleCheckboxChange1}
          />
          Show employee name with code
        </label>
        <label className="checkbox pb-4">
          <input
            
            type="checkbox"
            checked={isChecked2}
            onChange={handleCheckboxChange2}
          />
          Show disable employees in report
        </label>
        <label className="checkbox">
          <input
            type="checkbox"
            checked={isChecked3}
            onChange={handleCheckboxChange3}
          />
          Use electronic signature
        </label> */}
        <div className="update-button d-flex justify-content-end">
          <button className="button-outline mt-3" onClick={UpdateBtn}>
           Update</button>
        </div>
      </div>
      
    </div>
  );
}
export default Preferences;
